<section class="content">
    <div class="container">
        <div #textRef class="text" [class.expanded]="expanded" [innerHTML]="text"> </div>
        @if (!expanded) {
        <div class="ellipsis">{{ "..." }}</div>
        }
    </div>
    <div class="buttonContainer">
        <button
            class="link"
            type="button"
            [attr.aria-expanded]="expanded"
            [attr.aria-controls]="'text'"
            (click)="toggleExpanded()">
            @if (!expanded) {

            <span i18n="@@node--hermes-product-display-default.expand">See more</span>

            } @if (expanded) {

            <span i18n="@@node--hermes-product-display-default.less-details">See less</span>

            }
            <span i18n="@@hermes-product-display-default.text-on-category" hSrOnlyNoSnippet>
                &nbsp;text on category
            </span>
            @if (this.gridFacade.category$ | async; as currentCategory) {
            <span hSrOnlyNoSnippet>&nbsp;{{ currentCategory.name }} {{ currentCategory.masterCategoryName }}</span>
            }
        </button>
    </div>
</section>
